import '../../plugins/iCheck/custom.css';
import '../../plugins/iCheck/icheck';

/* @ngInject */
export default function ($timeout) {
	return {
		restrict: 'A',
		require:  'ngModel',
		link:     function ($scope, element, $attrs, ngModel) {
			return $timeout(() => {
				var value;
				value = $attrs['value'];

				$scope.$watch($attrs['ngModel'], (newValue) => {
					$(element)
						.iCheck('update');
				});

				return $(element)
					.iCheck({
						checkboxClass: 'icheckbox_square-green',
						radioClass:    'iradio_square-green',
					})
					.on('ifChanged', (event) => {
						if ($(element)
								.attr('type') === 'checkbox' && $attrs['ngModel']) {
							$scope.$apply(() => {
								return ngModel.$setViewValue(event.target.checked);
							});
						}

						if ($(element)
								.attr('type') === 'radio' && $attrs['ngModel']) {
							return $scope.$apply(() => {
								return ngModel.$setViewValue(value);
							});
						}
					});
			});
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/icheck.js